/* eslint-disable react/jsx-no-bind */
import styles from './BestFeatures.module.css'
import Check from 'shared-svg/Check.svg'
import Close from 'shared-svg/CloseBold.svg'
import IconedListItem from 'shared-components/ui/IconedListItem'
import ProsConsPane from 'shared-components/ui/ProsConsPane'
import clsx from 'clsx'
import { CSSProperties, useState } from 'react'
import { useScrollHeight } from 'shared-components/hooks/use-scroll-height'
import { AppEventsContext } from '../contexts/AppEventsContext'

interface BestFeaturesProps {
  negatives: readonly string[] | null
  positives: readonly string[] | null
  paneClassName?: string
  negativeClassName?: string
  positiveClassName?: string
  unfold?: boolean
}

const BestFeatures: React.VFC<BestFeaturesProps> = ({
  paneClassName,
  negativeClassName,
  positiveClassName,
  negatives,
  positives,
  unfold,
}) => {
  const [opened, setOpened] = useState(unfold ?? false)
  const { ref: refNegative, height: heightNegative } = useScrollHeight<HTMLDivElement>()
  const { ref: refPositive, height: heightPositive } = useScrollHeight<HTMLDivElement>()
  const { appEvent } = AppEventsContext.useContainer()

  const FEATURES_LIMIT = 3
  const [collapsedDesktop, setCollapsedDesktop] = useState(() => {
    if (
      (negatives && negatives.length > FEATURES_LIMIT) ||
      (positives && positives?.length > FEATURES_LIMIT)
    ) {
      return true
    }
    return false
  })

  return (
    <>
      <ProsConsPane
        pros="Pros"
        cons="Cons"
        className={clsx(styles.buttonOpen, paneClassName, {
          [styles.hidden]: !positives && !positives,
        })}
        opened={opened}
        onClick={() => setOpened(s => !s)}
      />
      <div
        ref={refPositive}
        className={clsx(positiveClassName, styles.features, { [styles.featuresOpened]: opened })}
        style={{ '--scroll-height': `${heightPositive}px` } as CSSProperties}
      >
        {positives && (
          <>
            <div className={clsx(styles.colorPositive, styles.title)}>{'Positives'}</div>
            {positives.map((positive, index) => (
              <IconedListItem
                className={clsx({
                  [styles.hiddenDesktop]: collapsedDesktop && index >= FEATURES_LIMIT,
                })}
                icon={Check}
                key={index}
                iconClassName={styles.colorPositive}
              >
                {positive}
              </IconedListItem>
            ))}
          </>
        )}
      </div>
      <div
        ref={refNegative}
        className={clsx(negativeClassName, styles.features, { [styles.featuresOpened]: opened })}
        style={{ '--scroll-height': `${heightNegative}px` } as CSSProperties}
      >
        {negatives && (
          <>
            <div className={clsx(styles.colorNegative, styles.title)}>{'Negatives'}</div>
            {negatives.map((negative, index) => (
              <IconedListItem
                className={clsx({
                  [styles.hiddenDesktop]: collapsedDesktop && index >= FEATURES_LIMIT,
                })}
                icon={Close}
                key={index}
                iconClassName={styles.colorNegative}
              >
                {negative}
              </IconedListItem>
            ))}
          </>
        )}
        {collapsedDesktop && (
          <button
            className={styles.showMore}
            type="button"
            onClick={() => {
              setCollapsedDesktop(false)
              appEvent({
                event: 'widget-interaction',
                widgetType: 'Clearbuy Best List Topper',
                label: 'Read more',
                url: window.location.href,
              })
            }}
          >
            {'Read more...'}
          </button>
        )}
      </div>
    </>
  )
}

export default BestFeatures
